import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';

export default class VerticalSteppers extends PureComponent {
    static propTypes = {
        steps: PropTypes.array.isRequired,
        activeStep: PropTypes.number.isRequired,
    };

    render() {
        const { steps, activeStep, ...stepperProps } = this.props;

        return (
            <Stepper activeStep={activeStep} orientation="vertical" {...stepperProps}>
                {steps.map(({ label, content }) => {
                    return (
                        <Step key={label}>
                            <StepLabel>
                                <FormattedMessage id={label} />
                            </StepLabel>
                            <StepContent>{content}</StepContent>
                        </Step>
                    );
                })}
            </Stepper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/Steppers/Steppers.jsx